import React from 'react';
import './ProgramNewPage.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import CompanyPage from './CompanyPage';
import MaskedInput from '../components/MaskedInput';
import AdminPage from './AdminPage';
import ErrorComponent from '../components/ErrorComponent';

export default class LgpdReportPage extends PageComponent {
  static PageInfo = {

    path: "/LgpdReport",
    parent: AdminPage,
    name: "menu.lgpd",
    permission: { "CONFIGURATION_USERS_ACCESSING": true  },
    access: { 1: true },
    icon: "file-alt"
  }

  constructor(props) {
    super(props);
  }

  downloadReport() {
    var f = "LGPD_Report_Accepts.xlsx";
    this.setState({ isModalVisible: "downloading", modalInitializing: true });
    Connection.Secure(Connection.service + 'Report/LGPD/Accepts/')
      .then(res => res.blob())
      .then(blob => {
        this.setState({ isModalVisible: null });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = f;
        a.setAttribute('target', '_blank');
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
      });
  }

  render() {
    return (
      <Container context={this.constructor}>

        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  <div>
                    <div style={{ padding: 20 }}>
                      <div style={{ textAlign: "left", marginTop: 30 }}>
                        <Button variant="info" size="lg" onClick={() => this.downloadReport()}>{Labels.GetLabel("generic.lgpdReport")}</Button>
                      </div>
                    </div>
                  </div>
                </div>
          }
        </div>
      </Container >
    );
  }
} 